import axios from 'axios'

// baseURL
axios.defaults.baseURL = '/jiance';
// 添加请求拦截器
// axios.interceptors.request.use(
//   function (config) {
//     // 在发送请求之前做些什么
//     return config;
//   },
//   function (error) {
//     // 对请求错误做些什么
//     return Promise.reject(error);
//   });

// 添加请求拦截器
axios.interceptors.request.use(config => {
	// 在发送请求之前做些什么
	//config.headers.Authorization = window.sessionStorage.getItem('token')
	return config
})
// 添加响应拦截器
// http response 拦截器
axios.interceptors.response.use(
			//拦截响应，做统一处理
			response => {
				
				return response;
			},
			//接口错误状态处理，也就是说无响应时的处理
			error => {
				//return Promise.reject(error.response.status) // 返回接口返回的错误信息
			})


		export default axios
